import { render, staticRenderFns } from "./SelectGrade.vue?vue&type=template&id=23f8ba1c&scoped=true"
import script from "./SelectGrade.vue?vue&type=script&lang=js"
export * from "./SelectGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8ba1c",
  null
  
)

export default component.exports